import React from 'react';
import BCScrollbars, { BCScrollbarRef, OnScrollbarsScroll } from '../../BCScrollbars';
import Styles from '../assets/styles.scss';
import { IChatMessages } from '../entities/IChatMessages';
import { IAssistantMessage, IMessage } from '../entities/IMessage';
import { AssistantMessage } from './AssistantMessage';
import { UserMessage } from './UserMessage';

const scrollStyle: React.CSSProperties = { height: '100%', width: '100%' };

const ChatMessages: React.FC<IChatMessages> = props => {
	const scrollbarRef = React.useRef<BCScrollbarRef>();
	const [shouldScroll, setShouldScroll] = React.useState(true);

	const scrollToBottom = () => {
		scrollbarRef.current?.scrollToBottom();
	};

	React.useLayoutEffect(() => {
		if (shouldScroll) {
			scrollToBottom();
		}
	}, [props.messages]);

	const renderMessage = (message: IMessage | IAssistantMessage, index: number) => {
		if (message.role === 'user') {
			return <UserMessage message={message} />;
		} else {
			return (
				<AssistantMessage
					message={message}
					onResponseSent={props.onResponseSent}
					scrollToBottom={scrollToBottom}
					isLastMessage={props.messages.length - 1 === index}
				/>
			);
		}
	};

	const onScroll: OnScrollbarsScroll = instance => {
		const { scrollOffsetElement } = instance.elements();
		const { scrollTop, clientHeight, scrollHeight } = scrollOffsetElement;

		const isAtBottom = scrollHeight - (scrollTop + clientHeight) <= 2;
		setShouldScroll(isAtBottom);
	};

	if (!props.messages.length) return null;

	return (
		<BCScrollbars
			styles={scrollStyle}
			ref={scrollbarRef}
			onScroll={onScroll}
		>
			<div className={Styles.messages}>
				{props.messages.map((message, index) => (
					<div
						key={message.key}
						className={Styles.row}
					>
						{renderMessage(message, index)}
					</div>
				))}
			</div>
		</BCScrollbars>
	);
};

export { ChatMessages };
